import React from 'react';
import { Hero } from './components/sections/Hero';
import { Testimonials } from './components/sections/Testimonials';
import { Problem } from './components/sections/Problem';
import { Tomos } from './components/sections/Tomos';
import { Bonos } from './components/sections/Bonos';
import { Offer } from './components/sections/Offer';
import { MoreTestimonials } from './components/sections/MoreTestimonials';
import { Guarantee } from './components/sections/Guarantee';
import { Faq } from './components/sections/Faq';
import { CostOfInaction } from './components/sections/CostOfInaction';
import { FinalCta } from './components/sections/FinalCta';
import { Footer } from './components/sections/Footer';
import { PurchaseNotifications } from './components/PurchaseNotifications';
export function App() {
  return <div className="min-h-screen w-full bg-white font-sans text-charcoal" data-id="element-0" data-mp="28te198rqp1kz">
      <Hero data-id="element-1" data-mp="23vktwcepa1j4" />
      <main data-id="element-2" data-mp="23w4gi6fape3h">
        <Testimonials data-id="element-3" data-mp="23u9vyt7xrnzx" />
        <Problem data-id="element-4" data-mp="23v2s7099qv3t" />
        <Tomos data-id="element-5" data-mp="23ti864kkyuk7" />
        <Bonos data-id="element-6" data-mp="3ik7gwiph6frp" />
        <Offer data-id="element-7" data-mp="3ikh5c1uvgeva" />
        <MoreTestimonials data-id="element-8" data-mp="3iiwfuqnezm4a" />
        <Guarantee data-id="element-9" data-mp="3ijpcuzwkmx98" />
        <Faq data-id="element-10" data-mp="3ii4qhxkeukmg" />
        <CostOfInaction data-id="element-11" data-mp="3mlavz2zp87rv" />
        <FinalCta data-id="element-12" data-mp="3mkhlps1j704z" />
      </main>
      <Footer data-id="element-13" data-mp="3mjq2lgp4euvl" />
      <PurchaseNotifications data-id="element-14" data-mp="3mj6ibtbzzuee" />
    </div>;
}